//  useBLAgeBandsBucketsData

import {
    ref, computed, watch, Ref
} from 'vue';
import { ApiQueryParams } from '@/pages/OperationsInsights/types/ApiQueryParams';
import { useLogger } from '@agyletime/vue-3-common/src/composables/logger';
import { useBacklogConfigurationsStore } from '@/stores/backlogConfigurationsStore';
import { fetchBacklogAgeBandsByBuckets } from '@/pages/OperationsInsights/services/fetchBacklogAgeBandsByBuckets';
import { ApiRespBacklogAgeBandsByBuckets } from '@/pages/OperationsInsights/types/BacklogMetricsResponse';
import { tfCsBLAgeBandByInterval } from '@/pages/OperationsInsights/composables/transformations/tfCsBLAgeBandByInterval';

const { ageBandConfigNamesStore } = useBacklogConfigurationsStore();

export function useBLAgeBandsBucketsData(queryParams: Ref<ApiQueryParams>) {
    const logger = useLogger('useBLAgeBandsBucketsData');
    const ageBandsData = ref<ApiRespBacklogAgeBandsByBuckets | null>(null);

    const isLoading = ref(false);
    const error = ref<string | null>(null);

    // High Chart - Backlog age by interval
    const ageBandChartSeries = computed(() => {
        const logger = useLogger('ageBandConfig-race-condition');
        logger.info('ageByInterval', {
            ageBandsDataValue: ageBandsData.value,
            ageBandConfigNamesStoreData: ageBandConfigNamesStore.data
        });
        // transform chart series
        return ageBandsData.value ? tfCsBLAgeBandByInterval(ageBandsData.value, ageBandConfigNamesStore.data) : [];
    });

    // Fetch Data
    const fetchData = async () => {

        if (!queryParams.value) return;
        if (!queryParams.value.workstreamDefinitionIds?.length) return;

        isLoading.value = true;
        error.value = null;

        try {
            const [ageBands] = await Promise.all([fetchBacklogAgeBandsByBuckets(queryParams.value)]);
            ageBandsData.value = ageBands;
        } catch (err) {
            error.value = 'Failed to fetch backlog age band data by interval';
            logger.error('Failed to fetch backlog age band data by interval', { error: err });
        } finally {
            isLoading.value = false;
        }
    };

    // Watch queryParams and fetch data when they change
    watch(queryParams, fetchData, { immediate: true, deep: true });
    return {
        ageBandChartSeries,
        isLoading,
        error,
        fetchData
    };

}